import React, { useState } from 'react';
import { Button, Nav } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

import arrow_down_fill from '../../img/arrow-down-fill.svg';
import arrow_up_fill from '../../img/arrow-up-fill.svg';
import share_icon from '../../img/share.svg';

import { downloadFile } from '../../services/apiClient';


const CabinetZdoMenuLeft = ({  
  onMenuItemClick,  
  onAddGroup, 
  onAdditionalLinkClick, 
  activeItem,
  badges={},
  data,
  cabinet,
  ExitFromEdit
}) => {
  const [isExpanded, setIsExpanded] = useState('');

  const { menuItems, level2Items, additionalLinks, title, rightPossible} = data;

  const navigate = useNavigate();

  const handleMenuItemClick = (itemId, event) => {
    event.preventDefault();
    //setActiveItem(itemId);
    
    if (level2Items && level2Items[itemId] && isExpanded !== itemId) {
       setIsExpanded(itemId);
    } else {
      setIsExpanded('');
    }

    if (onMenuItemClick) {
      onMenuItemClick(itemId);
    }
  };

  const handleAddGroup = (event) => {
    event.preventDefault();
    
    if (onAddGroup) {
      onAddGroup();
    }
  };

  return (
    <div className="sidebar-content">
      {/* Button Wrapper */}
     {rightPossible && rightPossible.isPossibleAddGroup && title && <div className="button-wrapper">
        <Button className="new-app-btn" onClick={handleAddGroup}>
          <i className="fa-solid fa-plus me-2"></i>{title}
        </Button>
      </div>}
      
      {/* Sidebar Menu */}
      <nav className="sidebar-nav">
        <Nav className="flex-column">
          {menuItems.filter(m=>(!m.hasOwnProperty("active") || (m.active))).map((item) => (
            <Nav.Item key={item.id}>
              <Nav.Link
                href={item.href}
                className={activeItem === item.id ? 'menu-active' : ''}
                onClick={(e) => handleMenuItemClick(item.id, e)}
              >
                <img src={item.icon} alt={item.label} className="nav-icon" />
                <span>{item.label}</span>
                
                {item.hasDropdown && (
                  <img 
                    src={isExpanded == item.id ? arrow_up_fill : arrow_down_fill} 
                    alt="expand" 
                    className="expand-icon ms-auto"
                  />
                )}
                
                {badges[item.id] && (
                  <span className="badge bg-primary ms-auto">{badges[item.id]}</span>
                )}
                
                {!item.hasDropdown && !item.badge && (
                  <div className="ms-auto" style={{ width: '16px' }}></div>
                )}
              </Nav.Link>
              
              {/* Подменю для групп (если раскрыто) */}
              {item.id === isExpanded && level2Items[item.id].filter(m=>(!m.hasOwnProperty("active") || (m.active))).map(item2=>
                <div className="submenu">
                  <Nav className="flex-column">
                    <Nav.Item>
                      <Nav.Link 
                        href="" 
                        className={activeItem === item2.id ? 'menu-active' : ''}
                        style={{ marginLeft: '17%', width: '230px'}}
                        onClick={(e) => {
                          e.preventDefault();
                          if (onMenuItemClick) {
                            onMenuItemClick(item2.id);
                          }
                        }}
                      >
                        {item2.label}
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>
                </div>
              )
              }
            </Nav.Item>
          ))}
        </Nav>
        
        <div className="nav-divider"></div>
        
        {/* Дополнительные ссылки */}
        {additionalLinks.filter(m=>(!m.hasOwnProperty("active") || (m.active))).map((link) => (
          <div className="knowledge-base" key={link.id}>
            <Nav.Link 
              href={link.href}
              className="knowledge-link"
              onClick={(e) => {
                e.preventDefault();
                if (onAdditionalLinkClick) {
                  onAdditionalLinkClick(link.id);
                }
                
                if(link && link.download) {

                  const { url, name } = link.download;

                  downloadFile(url, name, 'post');

                } else {
                  navigate(link.href, {replace: true})
                }
              }}
            >
              <img src={link.icon} alt={link.label} className="nav-icon" />
              <span>{link.label}</span>
              <img src={share_icon} alt="Share" className="nav-icon-share ms-2" />
            </Nav.Link>
          </div>
        ))}
        {ExitFromEdit && <ExitFromEdit />}
        <div class="knowledge-base" style={{ textAlign: 'center', marginTop: '2rem', fontSize: '12px'}}><span >СЕЗ ЗДО @{cabinet.label}</span></div>
        {cabinet.number && cabinet.address && 
          <div class="knowledge-base" 
            style={{ textAlign: 'justify', marginTop: '2rem', fontSize: '12px'}}>
              <span >{cabinet.number} {cabinet.name} {cabinet.address?.string} </span></div>}
      </nav>
    </div>
  );
};

// Пропсы по умолчанию
CabinetZdoMenuLeft.defaultProps = {
  initialActiveItem: 'groups',
  onMenuItemClick: null,
  onAddGroup: null,
  onSubmenuClick: null,
  onAdditionalLinkClick: null
};

export default CabinetZdoMenuLeft;